import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectSede } from 'sharedComponents/select'

const IdSedeFormGroup = ({ fIsSubmitting, iError, iTouched }) => {
  return (
    <Form.Group>
      <Form.Label md={4} text='Establecimiento' alignRightAt='md' />
      <Col md={8}>
        <Field name='_idSede'>
          {({ field }) => <SelectSede {...field} id='select-idSede' isInvalid={iTouched && iError} disabled={fIsSubmitting} />}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdSedeFormGroup)
